<template>
  <div>
    <EsProfileHeader>
      <template #profile-header>
        <div class="header-title">
          {{ parentRole.name}}
        </div>
      </template>
      <template #profile-overview>
        <div class="columns">
          <div class="column">
            <div class="column-content">
              <div class="column-title">{{ parentRole.lastUpdateDate | formatDate }}</div>
              <div class="column-subtitle">Last Updated</div>
            </div>
          </div>
        </div>
      </template>
    </EsProfileHeader>
    <div class="tabs-container no-bottom-border">
      <es-tabs :tabs="tabs" ref="tabs"></es-tabs>
    </div>
    <router-view @updateHeader="updateHeader"/>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
} from '@fortawesome/pro-light-svg-icons';
import EsProfileHeader from '@/components/EsProfileHeader.vue';
import BreadcrumbsManager from '@/mixins/BreadcrumbManager';
import moment from 'moment';
import EsTabs from './EsTabs.vue';

library.add(
);

export default {
  mixins: [BreadcrumbsManager],
  components: {
    EsProfileHeader,
    EsTabs,
  },
  data() {
    return {
      parentRole: [],
      tabs: [],
    };
  },
  async mounted() {
    if (this.$route.params.role) {
      this.parentRole = this.$route.params.role;
    } else {
      await this.getRoleHeader();
    }
    this.setBreadcrumbs(this.parentRole.name);
  },
  created() {
    this.tabs = [
      {
        path: 'details',
        label: 'DETAILS',
      },
      {
        path: 'privileges',
        label: 'PRIVILEGES',
      },
    ];
  },
  computed: {
    ...mapGetters({
      activeModule: 'appModules/getActiveModule',
      allModules: 'appModules/getAllModules',
    }),
  },
  methods: {
    async updateHeader() {
      await this.getRoleHeader();
      this.setBreadcrumbs(this.parentRole.name);
    },
    async getRoleHeader() {
      const { roleId } = this.$route.params;
      const res = await axios.get(`roles/${roleId}`);
      this.parentRole = res.data;
    },
    setBreadcrumbs(label) {
      this.setBreadcrumb([
        {
          text: 'Security Manager',
          to: {
            name:
            (this.activeModule.name === 'locationID') ? 'LISecurityManager'
              : (this.activeModule.name === 'directMatch') ? 'DMSecurityManager'
                : 'PidSecurityManager',
          },
        },
        { text: ':roleName', to: {} },
      ]);
      this.replaceBreadcrumb({
        find: ':roleName',
        replace: { text: `${label}`, to: {} },
      });
    },
  },
  filters: {
    formatDate(value) {
      if (value) {
        return moment(value).format('MM/DD/YYYY');
      }
      return null;
    },
  },
};
</script>

<style lang="sass" scoped>
  .document
    max-width: 928px
  .profile-overview
    position: center
</style>
